code{
    margin:.1rem .25rem 1rem .25rem;
    padding:0;
    color:black;
    font-family: monospace, monospace;

    text-shadow: 0 1px #fff;
    direction: ltr;
    text-align: left;
    word-spacing: normal;
    word-break: normal;
    word-wrap: normal;
    line-height: 1.2;
    -moz-tab-size: 2; -o-tab-size: 2; tab-size: 2;
    -webkit-hyphens: none; -moz-hyphens: none; -ms-hyphens: none; hyphens: none;

}

code ul{
    list-style-type: none;
    margin:0;
    padding-left:1rem;
}

code div.element{
    font-weight: bold;
    color:darkred;
    display:inline-block;
}

code div.element-content {
    font-weight: normal;
    display:inline-block;
}

code span.attr{
    font-weight: bold;
    color: #535353;
}

code span.attr-value{
    font-weight: normal;
}

code div.comment{
    color: darkgreen;
    font-style: italic;
}

code div.cdata {
    color:lightgray;
}
